import React from "react";
import "./PetTributes.scss";
import $ from "jquery";
import MyContext from "../MyContext";
import {FaUserCircle, FaTh,FaList, FaAngleRight} from "react-icons/fa";
import {ButtonTheme1, ButtonTheme2} from "../../res/styler/ButtonThemes/ButtonThemes";
import AwesomeSlider from 'react-awesome-slider';
import AwsSliderStyles from 'react-awesome-slider/dist/styles.css';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/dist/styles.css';
import 'react-awesome-slider/dist/custom-animations/open-animation.css';
import slider1 from "../../res/images/pet_tributes/slider1.jpg";
import slider2 from "../../res/images/pet_tributes/slider2.jpg";
import slider4 from "../../res/images/pet_tributes/slider4.jpg";
import slider5 from "../../res/images/pet_tributes/slider5.jpg";
import intro_cat from "../../res/images/pet_tributes/intro_cat.png";
import {Link} from "react-router-dom";
import ReactPaginate from 'react-paginate';
import NoSearchResults from "../NoSearchResults/NoSearchResults";

class PetTributes extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      pet_tributes : [],
      animals : [],
      animal_type_id : 0,
      search_input : "",
      filtered_pet_tributes:[],
      offset_value : 0,
      current_page : 0,
      per_page : 12,
      page_count : 0,
      page_no_input : 1
    }
    this.form_change = this.form_change.bind(this);
    this.handle_page_click = this.handle_page_click.bind(this);
    this.page_no_change = this.page_no_change.bind(this);
    this.page_no_form_submit = this.page_no_form_submit.bind(this);
    this.pet_tributes_XHR = {abort : () => {}}
    this.pet_tributes_page_Ref = React.createRef();
    this.pet_tribute_block_ref = React.createRef();
  }

  componentDidMount(){
    $(".header_container").addClass("transparent_header");
    if(this.props.history.location.state && typeof this.props.history.location.state == "object"){
      // console.log(this.props.history.location.state);
      this.setState(this.props.history.location.state,() => {
        // $(".single_pet_tribute").css({"height":"185px","width":"255px",opacity:1});
        this.pet_tributes_page_Ref.current.style.visibility = "visible";
      });
    }else{ 
      this.getPetTributes("",() => {
        // window.scrollTo({
        //   top : this.pet_tributes_page_Ref.current.offsetTop - 80,
        // });
        $("html,body").animate({ scrollTop: 0 }, "slow");
      });
    }
    var obj_this = this;
    $(".slider_block").on("click",".add_new_button",function(){
      obj_this.props.history.push("/Dashboard/PetTributes/New")
    });

    $(".pet_tribute_refresh").on("click",() => {
      obj_this.state.offset_value = 0;
      obj_this.state.current_page = 0;
      obj_this.setState({
        search_input : "",
        page_no_input : 1
      },() => {
        obj_this.getPetTributes("",() => {
          // window.scrollTo({
          //   top : obj_this.pet_tribute_block_ref.current.offsetTop - 80,
          //   behavior : "smooth"
          // });
        });
      });
    });
  }

  page_no_change(e){
    this.setState({
      page_no_input : e.target.value
    });
  }

  page_no_form_submit(e){
    e.preventDefault();
    this.setState({
      offset_value : (this.state.page_no_input -1) * this.state.per_page,
      current_page : this.state.page_no_input -1,
    },() => {
      this.getPetTributes(() => {
        window.scrollTo({
          top : this.pet_tribute_block_ref.current.offsetTop - 80,
          behavior : "smooth"
        });
      })
    });
  }

  form_change(e){
    this.state.offset_value = 0;
    this.state.current_page = 0;
    this.setState({
      [e.target.name] : e.target.value,
      page_no_input : 1
    },() => {
      this.getPetTributes(e.target.value,() => {
        window.scrollTo({
          top : this.pet_tribute_block_ref.current.offsetTop - 80,
          behavior : "smooth"
        });
      });
    });
   
  }

  handle_page_click(e){
    this.context.loading(1);
    this.setState({
      offset_value : e.selected * this.state.per_page,
      current_page : e.selected,
      page_no_input : e.selected +1
    },() => {
      this.getPetTributes(() => {
        window.scrollTo({
          top : this.pet_tribute_block_ref.current.offsetTop - 80,
          behavior : "smooth"
        });
      });
    });
  }

  getPetTributes(phrase, callback){
    const search_phrase = phrase??"";
    const animal_type_id = this.state.animal_type_id??"";
    console.log(animal_type_id)
    var obj_this = this;
    this.pet_tributes_XHR.abort();
    this.pet_tributes_XHR = $.ajax({
      url : process.env.REACT_APP_API + "/api/petTributes",
      data :{
        search_phrase : search_phrase,
        animal_type_id : animal_type_id,
        offset_value : this.state.offset_value,
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
     
      const animals = phrase?obj_this.state.animals:return_data.animals;
      obj_this.setState({
        pet_tributes : return_data.pet_tributes,
        filtered_pet_tributes : return_data.pet_tributes,
        animals : animals,
        page_count :  Math.ceil(return_data.page_count / obj_this.state.per_page),
      },() => {
        if(callback){
          callback();
        }
        obj_this.pet_tributes_page_Ref.current.style.visibility = "visible";
        // $(".single_pet_tribute").css({"height":"185px","width":"255px",opacity:1});
      });
      obj_this.context.setHistoryState({
        pet_tributes : return_data.pet_tributes,
        filtered_pet_tributes : return_data.pet_tributes,
        animals : animals,
        animal_type_id : obj_this.state.animal_type_id,
        page_count :  Math.ceil(return_data.page_count / obj_this.state.per_page),
        offset_value : obj_this.state.offset_value,
        current_page : obj_this.state.current_page,
        search_input : obj_this.state.search_input,
        page_no_input : obj_this.state.page_no_input,
      },obj_this.props.history);
      obj_this.context.loading(0);
    }).fail(function (jqXHR, textStatus) {
      if (textStatus != "abort") {
        alert("Network error");
      } 
    });
  }

  change_animal(animal_id,e){
    if($(e.target).hasClass("selected_filter")){
      var value = $(e.target).attr("id");
      if(value == animal_id){
        return;
      }
    }
    this.state.offset_value = 0;
    this.state.current_page = 0;
    // $(".filter").removeClass("selected_filter").addClass("unselected_filter");
    // $(e.target).removeClass("unselected_filter").addClass("selected_filter");
    const pet_tributes = this.state.pet_tributes;
    var filtered_pet_tributes = pet_tributes;
    $(".single_pet_tribute").css({"height":"0px","width":"0px",opacity:0});
    // if(animal_id){
      this.setState({
        animal_type_id : animal_id,
        search_input : "",
        pet_tributes : [],
        filtered_pet_tributes : [],
        page_no_input : 1
      },() => {
        this.getPetTributes("",() => {
          window.scrollTo({
            left : 0,
            top : this.pet_tribute_block_ref.current.offsetTop - 80,
            behavior : "smooth"
          });
        });
      });
    // }
    
  }

  componentWillUnmount(){
    $(".header_container").removeClass("transparent_header")
  }

  
  render(){
    const AutoplaySlider = withAutoplay(AwesomeSlider);
    return(
      <div className="pet_tribute_page_container" ref={this.pet_tributes_page_Ref}>
        <div className="slider_block block">
          <AutoplaySlider cssModule={AwsSliderStyles}
            play={true}
            animation="openAnimation"
            cancelOnInteraction={false} // should stop playing on user interaction
            interval={3000}
            onTransitionStart={this.onTransitionStart}
            onTransitionEnd={this.onTransitionEnd}
          >

            <div data-src={slider1} >
              <p className="slider_content">
                <div className="title">Little love</div>
                <div className="slider_title">
                Create a lasting tribute to <br></br> your pet’s memory depicting the<br></br>perfect expressions of your feelings  
                </div>
                <div className="buttons_container">
                  {/* <ButtonTheme2 label="Create Pet Tribute" onClick={() => this.props.history.push("/Dashboard/PetTributes/New")}></ButtonTheme2> */}
                </div>
              </p>
            </div>
            <div data-src={slider2}>
              <p className="slider_content">
                <div className="title">Little love</div>
                <div className="slider_title">Remember your pets on Amrityum,<br></br> Where they live forever
                </div>
                <div className="buttons_container">
                  {/* <ButtonTheme2 label="Create Pet Tribute" onClick={() => this.props.history.push("/Dashboard/PetTributes/New")}></ButtonTheme2> */}
                </div>
              </p>
            </div>
            <div data-src={slider4}>
              <p className="slider_content">
                <div className="title">Little love</div>
                <div className="slider_title">
                New everlasting memorials<br></br> for your beloved pets 
                </div>
                <div className="buttons_container">
                  {/* <ButtonTheme2 label="Create Pet Tribute" onClick={() => this.props.history.push("/Dashboard/PetTributes/New")}></ButtonTheme2> */}
                </div>
              </p>
            </div>
            <div data-src={slider5}>
              <p className="slider_content">
                <div className="title">Little love</div>
                <div className="slider_title">
                We assure you that you will be able<br></br> to keep your pet close to your heart
                </div>
                <div className="buttons_container">
                  {/* <ButtonTheme2 label="Create Pet Tribute" onClick={() => this.props.history.push("/Dashboard/PetTributes/New")}></ButtonTheme2> */}
                </div>
              </p>
            </div>
          </AutoplaySlider>
        </div>
        <div className="intro_block block">
          <div className="image_details_grid">
            <div className="image_container">
              <div className="image zoom_from_zero" style={{backgroundImage:"url('"+intro_cat+"')"}}></div>
            </div>
            <div className="details_grid_item">
              <div className="intro_title">About Pet tribute</div>
              <div className="intro_heading">Pet Tributes <span>& Memories</span></div>
              <div className="intro_content">
                We give great importance to human-pet bonds. We do understand how difficult it would be for one to lose a pet who is part of the family. Create everlasting memorials for your beloved pets. You can remember them on Amrityum and celebrate their existence in your life by sharing stories and preserving photographs, showcasing your homage to tamed companions. 
              </div>
              <div className="intro_content">
              Amrityum, therefore, is an online sanctuary where you can immortalise your much-missed pets eternally and share the cherished memories they have given. Guard and treasure the memories of your pets forever, even after they are long gone. Keep your pets ever closer to your hearts.
              </div>
              {/* <div className="list_grid">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -32 512.00011 512"><path d="m342.382812 239.351562c-23.039062-35.941406-62.277343-57.402343-104.964843-57.402343s-81.925781 21.460937-104.960938 57.402343l-55.515625 86.605469c-9.210937 14.367188-13.460937 30.96875-12.292968 47.996094 1.167968 17.03125 7.648437 32.890625 18.738281 45.875 11.097656 12.972656 25.761719 21.839844 42.40625 25.644531 16.644531 3.804688 33.707031 2.179688 49.339843-4.691406l1.046876-.464844c39.335937-16.945312 84.285156-16.789062 123.519531.464844 10.121093 4.449219 20.84375 6.699219 31.664062 6.699219 5.882813 0 11.800781-.667969 17.664063-2.003907 16.644531-3.800781 31.308594-12.667968 42.410156-25.644531 11.09375-12.972656 17.578125-28.835937 18.75-45.871093 1.171875-17.035157-3.078125-33.632813-12.289062-48.007813zm0 0"></path><path d="m91.894531 239.238281c16.515625-6.34375 29.0625-19.652343 35.328125-37.476562 5.964844-16.960938 5.476563-36.109375-1.378906-53.921875-6.859375-17.800782-19.335938-32.332032-35.132812-40.921875-16.59375-9.019531-34.824219-10.488281-51.3125-4.132813-33.171876 12.753906-48.394532 53.746094-33.929688 91.398438 11.554688 29.96875 38.503906 48.886718 65.75 48.886718 6.957031 0 13.933594-1.234374 20.675781-3.832031zm0 0"></path><path d="m199.613281 171.386719c41.46875 0 75.207031-38.4375 75.207031-85.683594 0-47.257813-33.738281-85.703125-75.207031-85.703125-41.464843 0-75.199219 38.445312-75.199219 85.703125 0 47.246094 33.734376 85.683594 75.199219 85.683594zm0 0"></path><path d="m329.496094 192.4375h.003906c6.378906 2.117188 12.886719 3.128906 19.367188 3.128906 30.242187 0 59.714843-22.011718 70.960937-55.839844 6.476563-19.472656 6.050781-40.0625-1.199219-57.972656-7.585937-18.75-21.644531-32.359375-39.589844-38.324218-17.949218-5.964844-37.359374-3.476563-54.660156 7-16.527344 10.007812-29.191406 26.246093-35.660156 45.71875-13.652344 41.078124 4.640625 84.273437 40.777344 96.289062zm0 0"></path><path d="m487.875 182.4375-.011719-.011719c-28.597656-21.125-71.367187-11.96875-95.347656 20.421875-23.957031 32.40625-20.210937 75.972656 8.34375 97.113282 10.414063 7.714843 22.71875 11.402343 35.3125 11.402343 21.949219 0 44.785156-11.203125 60.050781-31.804687 23.953125-32.40625 20.210938-75.972656-8.347656-97.121094zm0 0"></path></svg>
                <div>Abore et dolore magna aliqua ut enim veniam</div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -32 512.00011 512"><path d="m342.382812 239.351562c-23.039062-35.941406-62.277343-57.402343-104.964843-57.402343s-81.925781 21.460937-104.960938 57.402343l-55.515625 86.605469c-9.210937 14.367188-13.460937 30.96875-12.292968 47.996094 1.167968 17.03125 7.648437 32.890625 18.738281 45.875 11.097656 12.972656 25.761719 21.839844 42.40625 25.644531 16.644531 3.804688 33.707031 2.179688 49.339843-4.691406l1.046876-.464844c39.335937-16.945312 84.285156-16.789062 123.519531.464844 10.121093 4.449219 20.84375 6.699219 31.664062 6.699219 5.882813 0 11.800781-.667969 17.664063-2.003907 16.644531-3.800781 31.308594-12.667968 42.410156-25.644531 11.09375-12.972656 17.578125-28.835937 18.75-45.871093 1.171875-17.035157-3.078125-33.632813-12.289062-48.007813zm0 0"></path><path d="m91.894531 239.238281c16.515625-6.34375 29.0625-19.652343 35.328125-37.476562 5.964844-16.960938 5.476563-36.109375-1.378906-53.921875-6.859375-17.800782-19.335938-32.332032-35.132812-40.921875-16.59375-9.019531-34.824219-10.488281-51.3125-4.132813-33.171876 12.753906-48.394532 53.746094-33.929688 91.398438 11.554688 29.96875 38.503906 48.886718 65.75 48.886718 6.957031 0 13.933594-1.234374 20.675781-3.832031zm0 0"></path><path d="m199.613281 171.386719c41.46875 0 75.207031-38.4375 75.207031-85.683594 0-47.257813-33.738281-85.703125-75.207031-85.703125-41.464843 0-75.199219 38.445312-75.199219 85.703125 0 47.246094 33.734376 85.683594 75.199219 85.683594zm0 0"></path><path d="m329.496094 192.4375h.003906c6.378906 2.117188 12.886719 3.128906 19.367188 3.128906 30.242187 0 59.714843-22.011718 70.960937-55.839844 6.476563-19.472656 6.050781-40.0625-1.199219-57.972656-7.585937-18.75-21.644531-32.359375-39.589844-38.324218-17.949218-5.964844-37.359374-3.476563-54.660156 7-16.527344 10.007812-29.191406 26.246093-35.660156 45.71875-13.652344 41.078124 4.640625 84.273437 40.777344 96.289062zm0 0"></path><path d="m487.875 182.4375-.011719-.011719c-28.597656-21.125-71.367187-11.96875-95.347656 20.421875-23.957031 32.40625-20.210937 75.972656 8.34375 97.113282 10.414063 7.714843 22.71875 11.402343 35.3125 11.402343 21.949219 0 44.785156-11.203125 60.050781-31.804687 23.953125-32.40625 20.210938-75.972656-8.347656-97.121094zm0 0"></path></svg>
                <div>Quis nostrud exercitation ullamco laboris aliquip</div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -32 512.00011 512"><path d="m342.382812 239.351562c-23.039062-35.941406-62.277343-57.402343-104.964843-57.402343s-81.925781 21.460937-104.960938 57.402343l-55.515625 86.605469c-9.210937 14.367188-13.460937 30.96875-12.292968 47.996094 1.167968 17.03125 7.648437 32.890625 18.738281 45.875 11.097656 12.972656 25.761719 21.839844 42.40625 25.644531 16.644531 3.804688 33.707031 2.179688 49.339843-4.691406l1.046876-.464844c39.335937-16.945312 84.285156-16.789062 123.519531.464844 10.121093 4.449219 20.84375 6.699219 31.664062 6.699219 5.882813 0 11.800781-.667969 17.664063-2.003907 16.644531-3.800781 31.308594-12.667968 42.410156-25.644531 11.09375-12.972656 17.578125-28.835937 18.75-45.871093 1.171875-17.035157-3.078125-33.632813-12.289062-48.007813zm0 0"></path><path d="m91.894531 239.238281c16.515625-6.34375 29.0625-19.652343 35.328125-37.476562 5.964844-16.960938 5.476563-36.109375-1.378906-53.921875-6.859375-17.800782-19.335938-32.332032-35.132812-40.921875-16.59375-9.019531-34.824219-10.488281-51.3125-4.132813-33.171876 12.753906-48.394532 53.746094-33.929688 91.398438 11.554688 29.96875 38.503906 48.886718 65.75 48.886718 6.957031 0 13.933594-1.234374 20.675781-3.832031zm0 0"></path><path d="m199.613281 171.386719c41.46875 0 75.207031-38.4375 75.207031-85.683594 0-47.257813-33.738281-85.703125-75.207031-85.703125-41.464843 0-75.199219 38.445312-75.199219 85.703125 0 47.246094 33.734376 85.683594 75.199219 85.683594zm0 0"></path><path d="m329.496094 192.4375h.003906c6.378906 2.117188 12.886719 3.128906 19.367188 3.128906 30.242187 0 59.714843-22.011718 70.960937-55.839844 6.476563-19.472656 6.050781-40.0625-1.199219-57.972656-7.585937-18.75-21.644531-32.359375-39.589844-38.324218-17.949218-5.964844-37.359374-3.476563-54.660156 7-16.527344 10.007812-29.191406 26.246093-35.660156 45.71875-13.652344 41.078124 4.640625 84.273437 40.777344 96.289062zm0 0"></path><path d="m487.875 182.4375-.011719-.011719c-28.597656-21.125-71.367187-11.96875-95.347656 20.421875-23.957031 32.40625-20.210937 75.972656 8.34375 97.113282 10.414063 7.714843 22.71875 11.402343 35.3125 11.402343 21.949219 0 44.785156-11.203125 60.050781-31.804687 23.953125-32.40625 20.210938-75.972656-8.347656-97.121094zm0 0"></path></svg>
                <div>Eiusmod tempor incididunt labore.</div>
              </div> */}
              <ButtonTheme2 label="+ Create Pet Tribute" onClick={() => {
                if(!this.context.session){
                  this.context.confirm("Sign in to create a Pet Tribute",() => {
                    this.props.history.push({ pathname: "/Login", url : "/Dashboard/PetTributes/New"})
                  });
                  return;
                }else{
                  this.props.history.push("/Dashboard/PetTributes/New");
                }
              }}></ButtonTheme2>
              <ButtonTheme2 label="View All" onClick={() => {
                this.state.offset_value = 0;
                this.state.current_page = 0;
                this.setState({
                  page_no_input : 1
                },() => {
                  this.getPetTributes("",() => {
                    window.scrollTo({
                      top : this.pet_tribute_block_ref.current.offsetTop -100,
                      behavior : "smooth"
                    });
                  });
                });
              }} className="view_pet_tribute_button"></ButtonTheme2>
            </div>
          </div>
        </div>
        <div className="search_view_type_block">
          <div>
          </div>
          <div>
            <div className="filter_search_toggle_container">
              <div className="search_container">
                <input
                  className="search_input"
                  name="search_input"
                  type="text"
                  value={this.state.search_input}
                  onChange={this.form_change}
                  placeholder="Search"
                />
                <i className="fas fa-search search_icon"></i>
              </div>
              <div className="notices_view_type_button_container">
                <div className="image_view_button selected_view_type"
                onClick={() => {
                  $(".image_view_button").addClass("selected_view_type")
                      $(".text_view_button").removeClass("selected_view_type")
                  $(".pet_tributes_grid").css("display","grid");
                  $(".table_container").css("display","none");
                }}
                ><FaTh /></div>
                <div className="text_view_button"
                onClick={() => {
                  $(".image_view_button").removeClass("selected_view_type")
                      $(".text_view_button").addClass("selected_view_type")
                  $(".pet_tributes_grid").css("display","none");
                  $(".table_container").css("display","block");
                }}
                ><FaList /></div>
              </div>
            </div>
          </div>
        </div>

        <div className="filter_block block" ref={this.pet_tribute_block_ref}>
          <div className="filter_container">
            <div className={this.state.animal_type_id?"filter unselected_filter":"filter selected_filter"} id="0" onClick={(e) => this.change_animal(0,e)}>All</div>
            {this.state.animals && this.state.animals.map((item,idx) => (
              <div className={this.state.animal_type_id == item.id?"filter selected_filter":"filter unselected_filter"} id={item.id} onClick={(e) => this.change_animal(item.id,e)} key={idx}>{item.animal}</div>
            ))}
          </div>
        </div>
        <div className="mobile_search_block">
          <div className="mobile_search_container">
            <input
              className="search_input"
              name="search_input"
              type="text"
              value={this.state.search_input}
              onChange={this.form_change}
              placeholder="Search"
            />
            <i className="fas fa-search search_icon"></i>
          </div>
        </div>
        <div className="pet_tribute_block block" >
          <div className="pet_tributes_grid">
            {this.state.filtered_pet_tributes && this.state.filtered_pet_tributes.map((item,idx) => (
              <Link className="single_pet_tribute" key={idx} to={"/PetTributes/"+item.id}>
                <div className="notice_image" 
                    style={{backgroundImage:item.image_src1?"url('"+process.env.REACT_APP_CDN_URL+"/"+item.entered_by+"/pet_tribute_images/"+item.image_src1+"')":item.image_src2 ? "url('"+process.env.REACT_APP_CDN_URL+"/"+item.entered_by+"/pet_tribute_images/"+item.image_src2+"')":item.image_src3?"url('"+process.env.REACT_APP_CDN_URL+"/"+item.entered_by+"/pet_tribute_images/"+item.image_src3+"')":""}} />
                <div className="notice_details">
                  <div className="person_name">{item.name}</div>
                  <div className="animal">{item.animal}</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
        <div className="table_container">
          <div className="custom_table_theme2" style={{display:this.state.pet_tributes.length?"table":"none"}}>
            <div className="table_row header">
              <div className="table_cell sl_no">Sl No.</div>
              <div className="table_cell"></div>
              <div className="table_cell fullname">Name</div>
              {this.state.animal_type_id?"":
              <div className="table_cell">Category</div>}
              <div className="table_cell">Breed</div>
              <div className="table_cell">Age</div>
              <div className="table_cell">Born</div>
              <div className="table_cell">Passed Away</div>
              <div className="table_cell">Published By</div>
            </div>
            {this.state.pet_tributes &&
            this.state.pet_tributes.map((item, idx) => (
            <Link
              className="table_row body"
              key={idx}
              to={"/PetTributes/"+ item.id}
            >
              <div className="table_cell sl_no">{this.state.offset_value+idx+1}</div>
              <div className="table_cell">
              {item.image_src1 || item.image_src2 || item.image_src3?
                <div className="person_image" 
                  style={{backgroundImage:item.image_src1?"url('"+process.env.REACT_APP_CDN_URL+"/"+item.entered_by+"/pet_tribute_images/"+item.image_src1+"')":item.image_src2 ? "url('"+process.env.REACT_APP_CDN_URL+"/"+item.entered_by+"/pet_tribute_images/"+item.image_src2+"')":item.image_src3?"url('"+process.env.REACT_APP_CDN_URL+"/"+item.entered_by+"/pet_tribute_images/"+item.image_src3+"')":""}}
                ></div>
                :
                <div className="person_image"><FaUserCircle size={60} color="lightgrey" /> </div> 
              } 
              </div>
              <div className="table_cell fullname">{item.name} {item.surname}</div>
              {this.state.animal_type_id?"":
              <div className="table_cell">{item.category}</div>}
              <div className="table_cell">{item.breed}</div>
              <div className="table_cell">{item.age}</div>
              <div className="table_cell">{item.date_of_birth?new Date(item.date_of_birth).toLocaleDateString('en-GB'):""}</div>
              <div className="table_cell">{item.date_of_death?new Date(item.date_of_death).toLocaleDateString('en-GB'):""}</div>
              <div className="table_cell">{item.published_by}</div>
            </Link>
            ))}
          </div>
        </div>
        {
          this.state.filtered_pet_tributes.length?"":
          <NoSearchResults/>
        }
        <div className="pagination_container" style={{display:this.state.pet_tributes.length && this.state.page_count > 1?"block":"none"}}>
          <ReactPaginate
            previousLabel={"PREV"}
            nextLabel={"NEXT"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={this.state.page_count}
            marginPagesDisplayed={1}
            pageRangeDisplayed={3}
            onPageChange={this.handle_page_click}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            forcePage={this.state.current_page}
          />
          <form className="page_no_search_form" onSubmit={this.page_no_form_submit}>
            <span className="page_count">Go to page</span>
            <input className="page_no_input"
              type="number"
              name="page_count"
              value={this.state.page_no_input}
              onChange={this.page_no_change}
              min={1}
              max={this.state.page_count}
            />
            <button type="submit" className="page_no_search_button">
              <span>Go</span>
              <FaAngleRight/>
            </button>
          </form>
        </div>
      </div>
    )
  }
}

export default PetTributes;
PetTributes.contextType = MyContext;